import { Link as RouterLink } from 'react-router-dom';
import { Box, Text } from '@primer/react';
import { CALENDLY_URL, trackContactClick } from '../utils/links';
import SEO from '../components/SEO';
import HeroBackground from '../components/HeroBackground';
import contactHeroVideo from '../assets/contact-hero-video.webm';
import contactHeroPoster from '../assets/posters/contact-hero-video-poster.jpg';

const options = [
  { label: 'New Client', href: CALENDLY_URL, external: true },
  { label: 'Careers', to: '/careers' },
];

const baseOptionSx = {
  display: 'inline-block',
  paddingX: 4,
  paddingY: 3,
  borderRadius: '6px',
  fontSize: 0,
  fontWeight: 600,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  textDecoration: 'none',
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
};

// Primary action (booking a call) — Primer primary button styling
const primarySx = {
  ...baseOptionSx,
  border: '1px solid rgba(27, 31, 36, 0.15)',
  backgroundColor: '#1f883d',
  color: '#ffffff',
  ':hover': { backgroundColor: '#1c8139' },
  ':active': { backgroundColor: '#197935' },
};

// Secondary action (Careers) — kept as an outline/ghost button
const secondarySx = {
  ...baseOptionSx,
  border: '1px solid rgba(255, 255, 255, 0.3)',
  backgroundColor: 'transparent',
  color: '#f5f1ea',
  ':hover': { backgroundColor: 'rgba(255, 255, 255, 0.08)' },
};

function Contact() {
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        paddingX: ['24px', '48px', '100px'],
        paddingBottom: '10vh',
        overflow: 'hidden',
        backgroundColor: '#05070a',
      }}
    >
      <SEO
        title="Contact Pegasus UX | Dallas UX Design Agency"
        description="Schedule a consultation with Pegasus UX, a Dallas, TX UX design agency, to discuss your enterprise, fintech, AI, or SaaS product's UX design, research, or strategy needs."
        keywords="contact ux agency dallas, hire ux designer dallas, contact UX design agency, book UX consultation, enterprise UX design inquiry, fintech UX consultation"
        path="/contact"
      />
      <HeroBackground videoSrc={contactHeroVideo} poster={contactHeroPoster} loop={false} />

      <Box sx={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(5, 7, 10, 0.6)' }} />

      <Text
        as="h1"
        sx={{
          position: 'relative',
          margin: 0,
          marginBottom: 3,
          maxWidth: '900px',
          fontFamily: "'Fraunces', serif",
          fontWeight: 300,
          fontSize: ['2.25rem', '3rem', '3.75rem'],
          lineHeight: 1.2,
          color: '#f5f1ea',
        }}
      >
        Contact Pegasus UX
      </Text>

      <Box sx={{ position: 'relative', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 3, marginTop: 3 }}>
        {options.map((option) =>
          option.external ? (
            <Box
              as="a"
              key={option.label}
              href={option.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackContactClick}
              sx={secondarySx}
            >
              {option.label}
            </Box>
          ) : (
            <Box as={RouterLink} key={option.label} to={option.to} sx={secondarySx}>
              {option.label}
            </Box>
          )
        )}
      </Box>
    </Box>
  );
}

export default Contact;
